/* tslint:disable:max-line-length */
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../common/buttons/PrimaryButton/PrimaryButton';
import { trackWebAppGAEvent } from '../../../common/helpers/plugins/website-google-analytics';
import { BotBuilderRoutes } from '../../../routes/bot-builder-routes';
import './FreeLeadGeneratorCongratulations.pcss';

type Props = {
  category: 'free_lead_generator' | 'automated_response_tool';
};
export const FreeLeadGeneratorCongratulations = ({ category }: Props) => {
  const history = useHistory();

  const location = useLocation<{ botId: string; businessEmail: string }>();

  const { botId, businessEmail } = location?.state || {};

  const onExitClick = () => {
    trackWebAppGAEvent('click', {
      category,
      label: `exit_btn`,
    });
    window.location.href = 'https://customers.ai/blog';
  };

  const onGoToDashboardClick = () => {
    trackWebAppGAEvent('click', {
      category,
      label: `dashboard_btn`,
    });
    if (Number(botId)) {
      history.push(
        BotBuilderRoutes.dashboard.getLink({ chatbotId: Number(botId) }),
      );
    } else {
      onExitClick();
    }
  };

  const emailText = businessEmail
    ? `We'll send your new leads right to ${businessEmail} each day`
    : "If you provided an email we'll send you new leads each day";

  return (
    <div className="free-lead-generator__congratulations">
      <div className="free-lead-generator__congratulations--container">
        <div className="free-lead-generator__congratulations--text-container">
          <div className="free-lead-generator__congratulations--congrats-text">
            THAT'S IT! YOU'RE ALL DONE!
          </div>
          <div className="free-lead-generator__congratulations--text">
            {`Congratulations on setting up the Free Facebook Lead Generator!
            ${emailText}. In the meantime, feel free to check out the rest of your new Chat
            Marketing dashboard!`}
          </div>
        </div>

        <div className="free-lead-generator__congratulations--buttons-container">
          <PrimaryButton
            onClick={onExitClick}
            color={ButtonColor.secondaryBlue}
            className="free-lead-generator__congratulations__exit-btn"
          >
            Exit
          </PrimaryButton>

          <PrimaryButton
            className="free-lead-generator__congratulations__cta-btn"
            color={ButtonColor.greenGradient}
            onClick={onGoToDashboardClick}
          >
            Go to Dashboard
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};
